import { useState } from 'react';

import { GRAY_SECONDARY } from 'constants/colors';

import { Box, Tooltip } from '@mui/material';

import { EventTooltipBody } from '../../../components/EventTooltip';

type Props = {
  width: number;
  durationInSeconds: number;
  distanceInMeters?: number;
  startingPoint: number;
};

export default function TravelTime({
  width,
  durationInSeconds,
  distanceInMeters,
  startingPoint
}: Props) {
  const [hovered, setHovered] = useState(false);

  return (
    <Tooltip
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      open={hovered}
      title={
        <EventTooltipBody
          durationInSeconds={durationInSeconds}
          distanceInMeters={distanceInMeters}
        />
      }
    >
      <Box
        sx={{
          position: 'absolute',
          zIndex: 1,
          left: startingPoint,
          top: 'calc(50% + 10px)', // Half of timeline + half of chip height
          height: '4px',
          width: `${width}px`,
          bgcolor: GRAY_SECONDARY
          //border: `4px solid ${DARK}`
        }}
      />
    </Tooltip>
  );
}
